import React, { useContext, useEffect, useMemo, useState } from "react";
import Text from "../../../../Diathrive/src/components/elements/Text";
import Button from "../../../../Diathrive/src/components/elements/Button";
import {
  BUTTON_TYPES,
  COLORS,
} from "../../../../Diathrive/src/utils/Constants";
import { NoAdvisors } from "../../../../Diathrive/src/utils/SvgIcons";
import {
  APPOINTMENTS,
  HTTP_METHODS,
} from "../../../../Diathrive/src/utils/URLConstants";
import { fetchApi } from "../../../../Diathrive/src/utils/ApiHelper";
import { loadingPauseContext } from "../../../../Diathrive/src/contexts/LoadingPauseContext";
import WebAppointmentCard from "./WebAppointmentCard";
import styles from "./styles";

const getAppointmentStatus = (appointment) => {
  if (appointment.status === "cancelled") {
    return "cancelled";
  }
  return new Date(appointment.startTime) > new Date() ? "upcoming" : "past";
};

const AdvisorsDashboard = ({ onSchedule }) => {
  const [appointments, setAppointments] = useState([]);
  const lpc = useContext(loadingPauseContext);

  useEffect(() => {
    getAppointments();
  }, []);

  const getAppointments = () => {
    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.GET, APPOINTMENTS)
      .then((response) => {
        lpc.setVisible(false);
        setAppointments(response.data.data.appointments);
      })
      .catch(() => {
        lpc.setVisible(false);
      });
  };

  const sections = useMemo(() => {
    const upcoming = [];
    const past = [];

    appointments.forEach((appt) => {
      const status = getAppointmentStatus(appt);
      if (status === "upcoming") {
        upcoming.push(appt);
      } else {
        past.push(appt);
      }
    });

    upcoming.sort(
      (a, b) => new Date(a.startTime) - new Date(b.startTime)
    );
    past.sort(
      (a, b) => new Date(b.startTime) - new Date(a.startTime)
    );

    return { upcoming, past };
  }, [appointments]);

  if (appointments.length === 0) {
    return (
      <div style={styles.container}>
        <div style={styles.emptyContainer}>
          <NoAdvisors />
          <Text
            variation="Headline4Bold"
            color={COLORS.blueDarkText}
            topMargin={16}
          >
            No advisors yet.
          </Text>
          <Text
            variation="Text1Regular"
            color={COLORS.grey1}
            topMargin={16}
          >
            Health Advisors are Certified Diabetes Care and Education
            Specialists (CDCES) and can help you manage lifestyle changes,
            medication and more.
          </Text>
          <Button
            style={styles.scheduleButton}
            buttonType={BUTTON_TYPES.Filled}
            titleColor={COLORS.white}
            title={"Schedule First Appointment"}
            onPress={onSchedule}
          />
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {sections.upcoming.length > 0 && (
        <>
          <div style={styles.sectionHeader}>
            <Text variation="Headline4Bold" color={COLORS.black}>
              Upcoming Appointments
            </Text>
          </div>
          {sections.upcoming.map((appt, index) => (
            <WebAppointmentCard
              key={appt.id || index}
              appointment={appt}
              status="upcoming"
            />
          ))}
        </>
      )}
      {sections.past.length > 0 && (
        <>
          <div style={styles.sectionHeader}>
            <Text variation="Headline4Bold" color={COLORS.black}>
              Past Appointments
            </Text>
          </div>
          {sections.past.map((appt, index) => (
            <WebAppointmentCard
              key={appt.id || index}
              appointment={appt}
              status={getAppointmentStatus(appt)}
            />
          ))}
        </>
      )}
      <Button
        style={styles.scheduleButton}
        buttonType={BUTTON_TYPES.Filled}
        titleColor={COLORS.white}
        title={"Schedule Appointment"}
        onPress={onSchedule}
      />
    </div>
  );
};

export default AdvisorsDashboard;
